import { type ProductBenefitGroup } from '@/domain/benefits/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface BenefitsContentProps {
  benefitGroups: ProductBenefitGroup[];
}

const BenefitsContent = ({ benefitGroups }: BenefitsContentProps) => {
  const sortedGroups = [...(benefitGroups ?? [])].sort((a, b) => (a.benefitGroup < b.benefitGroup ? -1 : 1));

  if (sortedGroups.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2, width: '100%' }}>
      {sortedGroups.map((group) => (
        <Tooltip
          key={group.idBenefitGroup}
          title={group.tooltip ?? ''}
          slotProps={{ tooltip: { sx: { minWidth: 300 } } }}
        >
          <Chip label={group.benefitGroup} variant="outlined" color="primary" />
        </Tooltip>
      ))}
    </Box>
  );
};

export default BenefitsContent;
